exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tooltip-container {\n  background-color: white;\n  border-radius: 4px;\n  box-shadow: 0 3px 6px #0000004D;\n  display: flex;\n  flex-direction: column;\n  margin: 0.4rem;\n  padding: 0.4rem;\n  transition: opacity 0.3s;\n  z-index: 2147483647;\n  max-width: 340px;\n  font-size: 14px;\n  font-family: 'Open Sans', sans-serif;\n}\n.tooltip-container .warning-block {\n  background-color: transparent;\n  border: none;\n}\n.tooltip-text {\n  font-size: 12.6px;\n  margin: 16px;\n  color: #828694;\n  line-height: 1.5em;\n}\n.tooltip-text .text-width-med {\n  width: 260px;\n}\n", ""]);

// exports
